__turbopack_context__.v({
  "contentInner": "carousel-module__tebK4G__contentInner",
  "contentOuter": "carousel-module__tebK4G__contentOuter",
  "horizontal": "carousel-module__tebK4G__horizontal",
  "item": "carousel-module__tebK4G__item",
  "root": "carousel-module__tebK4G__root",
  "srOnly": "carousel-module__tebK4G__srOnly",
  "vertical": "carousel-module__tebK4G__vertical",
});
